import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import IForm from '../../../../types/IForm';
import { AcceptDeclineForm } from '../../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';

export type PageToPageDeleteFormProps = {
  form: IForm;
  onSuccess?: () => void;
};

export function PageToPageDeleteForm({ form, onSuccess }: PageToPageDeleteFormProps) {
  const { t } = useSonTranslation('PageToPage');

  return (
    <AcceptDeclineForm
      form={form as any}
      onSuccess={onSuccess}
      headline={`${t('deleteModal.deleteConnection')}?`}
      messageSuccess={t('deleteModal.status.success')}
      messageSending={t('deleteModal.status.sending')}
      messageFail={t('deleteModal.status.fail')}
    />
  );
}
